import { render, staticRenderFns } from "./CustomerUse.vue?vue&type=template&id=82129a56&"
import script from "./CustomerUse.vue?vue&type=script&lang=js&"
export * from "./CustomerUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports